<template>
  <el-dialog :visible.sync="addDialogVisible" width="600px" title="添加课程" @close="close">
    <div class="clearfix">
      <el-button type="primary"  v-show="isBtnShow" round @click="toLink($router,'/course/live-add',true)">{{btn_text}}</el-button>
      <el-input placeholder="输入课程名称搜索"  v-model="searchName" style="width: 300px" class="r">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="mt20" v-loading="tableLoading">
    <el-table
      class="course-table mt20"
      ref="multipleTable"
      :data="listData.list"
      style="width: 100%"
      height="250"
      :header-cell-style="{backgroundColor: '#f5f7fa'}"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="30"></el-table-column>
      <el-table-column prop="course_name" label="课程名称" width="350"></el-table-column>
      <!-- <el-table-column prop="published_at" label="上架时间"> -->
      <el-table-column prop="published_at" label="状态">
         <template slot-scope="scope">
              <span v-show="scope.row.state==-1">删除</span>
              <span v-show="scope.row.state==1">定时上架</span>
              <span v-show="scope.row.state==2">已上架</span>
              <span v-show="scope.row.state==3">已下架</span>
          </template>
      </el-table-column>
    </el-table>
    </div>
    <div slot="footer" class="tc">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit()">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from "@/base/js/util";

import { _getAllCourseList } from "@/api/course";

export default {
  props: {
    addCourseVisible: {
      type: Boolean,
      default: true
    },
    isBtnShow:{
      type:Boolean,
      default:true
    },
    btn_text: {
      type: String,
      default: "新建课程"
    },
    btn_path: {
      type: String,
      default: "/course/liveadd"
    },
    search_method: {
      type: Function,
      default: function() {}
    }
  },
  created() {
  },
  data() {
    return {
      tableLoading:false,
      addDialogVisible: false,
      searchName: "",
      listSelectionList: [],
      course_list:[],
      listData: []
    };
  },
  methods: {
    //获取所有课程列表数据
    initCouresList() {
      this.tableLoading=true;
      _getAllCourseList({
        params: {
          size: 10,
          keywords: this.searchName,
          iswait:1
        }
      }).then(res => {
        // console.log(res);
        this.tableLoading = false;
        if (res.resultCode == 1) {
          this.listData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    toLink(...args) {
      util.toLink(...args);
    },
    close() {
      this.$emit("update:addCourseVisible", false);
    },
    search() {
      this.initCouresList()
    },
    selectionChange(val) {
      this.listSelectionList = val.map(_ => _.course_id);
      this.course_list=val.map(item=>{
        return{
          id:item.course_id,
          name:item.course_name
        }
      });
      // console.log(this.listSelectionList);
    },
    submit() {
      this.$emit("submitData", this.listSelectionList,this.course_list);
      this.close();
    }
  },
  watch: {
    addCourseVisible(newVal) {
      this.addDialogVisible = newVal;
      if(newVal){
        this.initCouresList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.course-table {
  margin-top: 20px;
}
</style>
